import { For, Show, createMemo } from 'solid-js';
import styles from '../st-attendance-grid.module.css';
import Icon from '../../st-icon/st-icon';
import { requireAttendanceGridContext } from '../st-attendance-grid';

export function AttendanceLegend() {
    const ctx = requireAttendanceGridContext();

    const attendanceCodes = createMemo(() => Array.from(ctx.attendanceCodesMap[0]().values()));

    return (
        <div class={styles['legend-container']}>
            <span class={styles['legend-title']}>Attendance Types</span>
            <Show when={attendanceCodes().length > 0}>
                <div class={styles['legend-codes-container']}>
                    <For each={attendanceCodes()}>
                        {(code) => (
                            <div class={styles['legend-code-item']} style={{ 'border-left': `3px solid ${code.color}` }}>
                                <span class={styles['legend-code-icon']} style={{ color: code.color }}>
                                    <Icon
                                        src={code.iconPath ?? code.iconClass ?? ''}
                                        size={18}
                                    />
                                </span>
                                <span class={styles['legend-code-text']}>
                                    <strong class={styles['legend-code-label']}>{code.code}</strong> - {code.description}
                                </span>
                            </div>
                        )}
                    </For>
                </div>
            </Show>
        </div>
    );
}
